/* eslint-disable @typescript-eslint/restrict-template-expressions */
import { router } from "@smakecloud/api-client-helper";
import { z } from "zod";
import { authedEndpoint } from "~/lib/api/builder";

const stockItemSchema = z.object({
    id: z.number(),
    count_on_hand: z.number(),
    media: z
        .object({
            sm: z.string().nullable(),
        })
        .nullable(),
    product: z.object({
        name: z.string().nullable(),
    }),
    variant: z.object({
        id: z.number(),
        code: z.string().nullable(),
        option_values: z.object({
            color: z.string().nullable(),
            size: z.string().nullable(),
        }),
    }),
});

const list = authedEndpoint.query(
    (searchParameters) => ({
        searchParams: searchParameters,
        url: "stock-items",
    }),
    {
        input: z
            .object({
                cursor: z.string(),
                filter: z
                    .object({
                        q: z.string(),
                    })
                    .partial(),
                per_page: z.number(),
            })
            .partial()
            .optional(),
        output: z.object({
            data: z.array(stockItemSchema),
            links: z.object({
                first: z.string().nullable(),
                last: z.string().nullable(),
                next: z.string().nullable(),
                prev: z.string().nullable(),
            }),
            meta: z.object({
                next_cursor: z.string().nullable(),
                path: z.string(),
                per_page: z.number(),
                prev_cursor: z.string().nullable(),
            }),
        }),
    },
);

const update = authedEndpoint.mutation(
    ({ id, count_on_hand, set_stock_item_type }) => ({
        json: {
            count_on_hand,
            set_stock_item_type,
        },
        method: "POST",
        url: `stock-items/${id}`,
    }),
    {
        input: z.object({
            id: z.number(),
            count_on_hand: z.number(),
            set_stock_item_type: z.string(),
        }),
        output: stockItemSchema,
    },
);

const exportList = authedEndpoint.mutation(
    (request) => ({
        json: request,
        method: "POST",
        url: "stock-items/export",
    }),
    {
        input: z.object({
            file_format: z.string(),
            separator: z.string(),
        }),
    },
);

const importList = authedEndpoint.mutation(
    (file) => {
        const formData = new FormData();
        formData.append("file", file);

        return {
            body: formData,
            headers: {
                /*
                 * Setting Content-Type to undefined fixes the issue with "missing boundary in multiform/form-data"
                 * See: https://stackoverflow.com/a/39281156
                 */
                "Content-Type": undefined,
            },
            method: "POST",
            url: "stock-items/import",
        };
    },
    {
        input: z.instanceof(Blob),
    },
);

export const stockItems = router({
    exportList,
    importList,
    list,
    update,
});
